import cn from "classnames"

import { HiddenValueCounter } from "@/atoms"

import styles from "./InsightsIcons.module.scss"

import type { InsightsIconsProps } from "."

export const checkInsightValue = (value: boolean | string) => {
  if (typeof value === "string") {
    return value.toLowerCase() === "yes"
  }

  return value
}

export const InsightsIcons = (props: InsightsIconsProps) => {
  const { items, values, hide, limit, isKeyTranslation, noTooltip } = props
  const { triggerable } = props // TODO: temporary class for demo }
  const useLimit = !!limit
  const valuesIsArray = Array.isArray(values)
  const activeValues = items.map((item, index: number) =>
    checkInsightValue(valuesIsArray ? values[index] : values[item.key])
  )
  // Running count of the active icons up to and including each position, so the
  // limit can be applied without mutating a counter mid-render.
  const activeThrough = activeValues.map(
    (_, index) => activeValues.slice(0, index + 1).filter(Boolean).length
  )
  const activeCount = activeThrough[activeThrough.length - 1] ?? 0

  const icons = items.map((item, index: number) => {
    const value = activeValues[index]

    if (hide && !value) return null
    if (useLimit && activeThrough[index] > limit) return null

    return (
      <item.Icon
        key={index}
        data-insight-key={item.key}
        data-tooltip-content={!noTooltip ? `insights.${item.key}` : undefined}
        data-tooltip-translation={isKeyTranslation}
        className={cn(styles.icon, !!value && styles.active)}
      />
    )
  })

  return (
    <div className={cn(styles.container, triggerable && styles.triggerable)}>
      {icons}
      {useLimit && activeCount > limit && (
        <HiddenValueCounter value={activeCount - limit} />
      )}
    </div>
  )
}
